import TwoFactorForm from './TwoFactorForm'
export default TwoFactorForm
